(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[214],{

/***/ 5920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AppContentContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_app_content_app_title_AppTitle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8990);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);




function AppContentContainer(param) {
    var title = param.title, routerPaths = param.routerPaths, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "bg-white",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("w-full", !routerPaths.includes("selling-hours") && "hidden", "md:block"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_app_content_app_title_AppTitle__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    Title: title,
                    routerPath: routerPaths
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full",
                children: children
            })
        ]
    });
};


/***/ }),

/***/ 8990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ app_title_AppTitle; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(6486);
// EXTERNAL MODULE: ./src/components/app-content/app-title/AppTitle.module.scss
var AppTitle_module = __webpack_require__(8351);
var AppTitle_module_default = /*#__PURE__*/__webpack_require__.n(AppTitle_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./public/images/print.svg
var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgPrint = function SvgPrint(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "".concat(props.prefix || "", "print_svg__a")
  }, _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M15.526 0c1.05 0 1.902.864 1.902 1.93v3.519a.53.53 0 0 1 0 .133h1.203c.9 0 1.76.365 2.393 1.012.633.648.984 1.525.976 2.436v3.992c-.006.978-.786 1.77-1.75 1.775h-2.802v3.766A1.436 1.436 0 0 1 16.022 20H5.978c-.784 0-1.42-.642-1.426-1.437v-3.807H1.75C.786 14.751.006 13.96 0 12.981V8.989c.006-1.883 1.512-3.407 3.368-3.407h1.153V1.93C4.521.864 5.373 0 6.423 0h9.103Zm.152 12.006H6.322v6.157h9.356v-6.157Zm2.953-4.648H3.368a1.61 1.61 0 0 0-1.598 1.61v3.992h2.782v-2.79h12.896v2.79l2.782-.02V8.969a1.61 1.61 0 0 0-1.599-1.611Zm-.12.841c.373 0 .677.308.677.688 0 .38-.304.687-.678.687a.683.683 0 0 1-.678-.687c0-.38.304-.688.678-.688Zm-2.954-6.403H6.453a.132.132 0 0 0-.131.133v3.52c0 .074.059.133.131.133h9.104c.072 0 .131-.06.131-.133v-3.52a.132.132 0 0 0-.131-.133Z"
  }))), /*#__PURE__*/react.createElement("clipPath", {
    id: "".concat(props.prefix || "", "print_svg__b")
  }, _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M24 0v24H0V0h24Z"
  })))), /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#".concat(props.prefix || "", "print_svg__a)"),
    transform: "translate(1 2)"
  }, _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v20H0V0z"
  })), /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#".concat(props.prefix || "", "print_svg__b)"),
    transform: "translate(-1 -2)"
  }, _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M1 2h22v20H1V2z"
  })))));
};
/* harmony default export */ var print = (SvgPrint);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 6 modules
var esm = __webpack_require__(5440);
;// CONCATENATED MODULE: ./src/components/app-content/app-title/AppTitle.tsx





var AppTitle = function(param) {
    var Title = param.Title, routerPath = param.routerPath;
    var t = (0,esm/* useTranslation */.$G)().t;
    var betTypeStyle = (AppTitle_module_default())[(0,lodash.toLower)(routerPath[1])] || "";
    var infoStyle = (0,lodash.toLower)(routerPath[0]) === "info" ? (AppTitle_module_default())[(0,lodash.toLower)(routerPath[0])] : "";
    var showPrint = [
        "selling-hours"
    ].includes(routerPath[routerPath.length - 1]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((AppTitle_module_default()).title, " ").concat(betTypeStyle, " ").concat(infoStyle, " ").concat((AppTitle_module_default())[routerPath[routerPath.length - 1]]),
        children: [
            Title,
            showPrint && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: (AppTitle_module_default()).print,
                onClick: function() {
                    try {
                        window.print();
                    } catch (e) {
                        console.log(e);
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(print, {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: t("Print")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var app_title_AppTitle = (AppTitle);


/***/ }),

/***/ 7214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _app_content_container_AppContentContainer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5920);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5440);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _AppSellingHours_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7431);
/* harmony import */ var _AppSellingHours_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_AppSellingHours_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);







var AppSellingHours = function(param) {
    var pageData = param.pageData, routerPath = param.routerPath;
    var ref;
    // const router = useRouter();
    // const [data, setData] = useState([]);
    // const [selectedOption, setSelectedOption] = useState('FootballFixedOddsBetting');
    var ref1 = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)(), t = ref1.t, i18n = ref1.i18n;
    // const [rootKeys, setRootKeys] = useState([] as string[]);
    // const [options, setOptions] = useState([]);
    // const [tableDatas, setTableDatas] = useState({} as any);
    // const [title, setTitle] = useState('');
    // const getRootKeys = useCallback(() => {
    //     let keys: any = [];
    //     let options: any = [];
    //     let tables: any = {};
    //     pageData.Content.data.forEach((i: any) => {
    //         keys.push(i.key);
    //         options.push({ label: i.datasetDisplayName.value, value: i.key });
    //         tables[i.key] = i.data;
    //     });
    //     setRootKeys(keys);
    //     setOptions(options);
    //     setTableDatas(tables);
    // }, [pageData.Content.data]);
    // useEffect(() => {
    //     getRootKeys();
    // }, [getRootKeys, pageData.Content.data, router.query.data, selectedOption]);
    // useEffect(() => {
    //     tableDatas[selectedOption] && setData(tableDatas[selectedOption]);
    // }, [selectedOption, tableDatas]);
    // useEffect(() => {
    //     const s = location.search.slice(1).split('&')[0];
    //     if (s && s.split('=')[0] == 'data' && rootKeys.includes(s.split('=')[1])) {
    //         setSelectedOption(s.split('=')[1]);
    //     } else {
    //         setSelectedOption(rootKeys[0]);
    //         router.replace(
    //             {
    //                 pathname: 'info/football/selling-hours',
    //                 query: { data: rootKeys[0] },
    //             },
    //             undefined,
    //             { shallow: true }
    //         );
    //     }
    //     options.forEach((o: any) => {
    //         if (o.value === selectedOption) {
    //             setTitle(o.label);
    //         }
    //     });
    // }, [options, rootKeys, router, selectedOption]);
    // const onChangeOption = (value: string) => {
    //     setSelectedOption(value);
    //     console.log(rootKeys, value);
    //     router.replace(
    //         {
    //             pathname: 'info/football/selling-hours',
    //             query: { data: value },
    //         },
    //         undefined,
    //         { shallow: true }
    //     );
    // };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_app_content_container_AppContentContainer__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        routerPaths: routerPath,
        title: pageData.Content.data[0].datasetDisplayName.value,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("table", {
                        className: (_AppSellingHours_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["special-selling-hours-header"]),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tbody", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                className: (_AppSellingHours_module_scss__WEBPACK_IMPORTED_MODULE_6___default().header),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        width: "10%",
                                        children: t("SellingHours.Date")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("td", {
                                        width: "13%",
                                        children: [
                                            " ",
                                            t("SellingHours.MatchDate")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        width: "14%",
                                        children: t("SellingHours.DigitalChannel")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        width: "19%",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                            href: "/retail-and-telebet/telephone-betting/",
                                            children: t("SellingHours.Telebet")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        width: "19.2%",
                                        children: t("SellingHours.TelebetAutomated")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        width: "12.2%",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                            href: i18n.language === "zh-HK" ? "https://entertainment.hkjc.com/entertainment/chinese/ocbb/index.aspx" : "https://entertainment.hkjc.com/entertainment/english/ocbb/index.aspx",
                                            children: t("SellingHours.Branch")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        children: t("SellingHours.Racecourses")
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_AppSellingHours_module_scss__WEBPACK_IMPORTED_MODULE_6___default().SellingHoursContent),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("table", {
                            className: (_AppSellingHours_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["special-selling-hours-table"]),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("thead", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_4___default()((_AppSellingHours_module_scss__WEBPACK_IMPORTED_MODULE_6___default().header), "header"),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                width: "10%",
                                                className: (_AppSellingHours_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["fixed-left"]),
                                                children: t("SellingHours.Date")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("td", {
                                                width: "13%",
                                                children: [
                                                    " ",
                                                    t("SellingHours.MatchDate")
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                width: "14%",
                                                children: t("SellingHours.DigitalChannel")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                width: "19%",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                                    href: "/retail-and-telebet/telephone-betting/",
                                                    children: t("SellingHours.Telebet")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                width: "19.2%",
                                                children: t("SellingHours.TelebetAutomated")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                width: "12.2%",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                                    href: i18n.language === "zh-HK" ? "https://entertainment.hkjc.com/entertainment/chinese/ocbb/index.aspx" : "https://entertainment.hkjc.com/entertainment/english/ocbb/index.aspx",
                                                    children: t("SellingHours.Branch")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                children: t("SellingHours.Racecourses")
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tbody", {
                                    children: pageData.Content.data[0].data.map(function(d) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                            className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(moment__WEBPACK_IMPORTED_MODULE_3___default()(d.date.value).format("DD/MM") === moment__WEBPACK_IMPORTED_MODULE_3___default()().format("DD/MM") && (_AppSellingHours_module_scss__WEBPACK_IMPORTED_MODULE_6___default().active)),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("td", {
                                                    className: (_AppSellingHours_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["fixed-left"]),
                                                    children: [
                                                        moment__WEBPACK_IMPORTED_MODULE_3___default()(d.date.value).format("DD/MM"),
                                                        " ",
                                                        t("SellingHours.".concat(moment__WEBPACK_IMPORTED_MODULE_3___default()(d.date.value).format("ddd")))
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    children: d.matchDate.value == 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: (_AppSellingHours_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["date-icon"])
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    children: d.digitalChannel.value
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    children: d.telebet.value
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    children: d.telebetAutomated.value
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    children: d.branch.value
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    children: d.racecourses.value
                                                })
                                            ]
                                        }, d.key);
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_AppSellingHours_module_scss__WEBPACK_IMPORTED_MODULE_6___default().footnote),
                dangerouslySetInnerHTML: {
                    __html: pageData === null || pageData === void 0 ? void 0 : (ref = pageData.Content) === null || ref === void 0 ? void 0 : ref.footnote.value
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (AppSellingHours);


/***/ }),

/***/ 8351:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"AppTitle_title__v29lb","racing":"AppTitle_racing__2sxjA","football":"AppTitle_football__peh_Y","marksix":"AppTitle_marksix__Cjj1F","print":"AppTitle_print__ogwEH","match-info":"AppTitle_match-info__C7I7R","info":"AppTitle_info__SdhGn"};

/***/ }),

/***/ 7431:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"SellingHoursContent":"AppSellingHours_SellingHoursContent__Lmm_a","special-selling-hours-table":"AppSellingHours_special-selling-hours-table__4gOsR","header":"AppSellingHours_header__iYkWy","fixed-left":"AppSellingHours_fixed-left__rCRa9","active":"AppSellingHours_active__vnCXg","date-icon":"AppSellingHours_date-icon__xK0FD","footnote":"AppSellingHours_footnote__HJn8e","special-selling-hours-header":"AppSellingHours_special-selling-hours-header__YoeHy","remark":"AppSellingHours_remark__fNLKb"};

/***/ })

}]);